// auth.js
import baseApi from './baseApi';

export const register = async (userData) => {
  return await baseApi.post('auth/register/', userData);
};

export const login = async (credentials) => {
  return await baseApi.post('auth/login/', credentials);
};

export const logout = async (refreshToken) => {
  return await baseApi.post('auth/logout/', { refresh: refreshToken });
};

export const refreshToken = async (refreshToken) => {
  return await baseApi.post('auth/refresh/', { refresh: refreshToken });
};